<div class="op-my-wp">
  <div class="op-my-wp--tabs">
    <div class="op-my-wp--toggle" role="tablist" [attr.aria-label]="text.tablist">
      <button *ngFor="let tab of tabs"
              type="button"
              role="tab"
              class="op-my-wp--tab"
              [class.op-my-wp--tab_selected]="tab === selected"
              [attr.aria-selected]="tab === selected"
              [attr.data-test-selector]="'op-my-wp--tab-' + tab.id"
              (click)="select(tab)">{{ tab.label }}</button>
    </div>
  </div>

  <wp-embedded-table class="op-my-wp--table"
                     [queryProps]="selected.queryProps"
                     [configuration]="configuration"></wp-embedded-table>
</div>
